export class UsernameOrPasswordIncorrectError extends Error {
	constructor() {
		super('Incorrect username or password given');
		this.name = 'UsernameOrPasswordIncorrectError';
	}
}
